import type {ComponentProps, RichTextData} from '@enonic/react-components'
import * as React from 'react'
import {Section, Container, Prose, ButtonLink} from '../primitives'

export interface InfoBoxData extends Record<string, unknown> {
  heading?: string
  body?: RichTextData
  linkUrl?: string
  linkLabel?: string
  linkNewTab: boolean
  linkAsButton: boolean
  backgroundColor: 'light-blue' | 'light-peach' | 'dark-blue'
}

const bgMap: Record<InfoBoxData['backgroundColor'], string> = {
  'light-blue': 'bg-slate-100',
  'light-peach': 'bg-peach-100',
  'dark-blue': 'bg-blue-900',
}

export const InfoBox = (props: ComponentProps) => {
  const {
    heading,
    body,
    linkUrl,
    linkLabel,
    linkNewTab,
    linkAsButton,
    backgroundColor,
  } = props.data as InfoBoxData

  if (!heading && !body && !(linkLabel && linkUrl)) return null

  const isDark = backgroundColor === 'dark-blue'
  const textLinkVariant = isDark ? 'text-link-white' : 'text-link'
  const buttonVariant = isDark ? 'button-white' : 'button'

  return (
    <Section>
      <Container>
        <div
          className={`col-span-full md:col-span-8 md:col-start-3 rounded-3xl p-6 md:p-10 ${bgMap[backgroundColor]} ${isDark ? 'text-white' : ''}`}
        >
          {heading && (
            <h2
              className={`text-3xl leading-normal mb-6 ${isDark ? 'text-white' : 'text-blue-900'}`}
            >
              {heading}
            </h2>
          )}
          {body && (
            <Prose
              data={body}
              meta={props.meta}
              common={props.common}
              component={props.component}
              className={`prose-flush ${isDark ? 'prose-invert' : ''}`.trim()}
            />
          )}
          {linkLabel && linkUrl && (
            <div className="mt-6">
              <ButtonLink
                href={linkUrl}
                label={linkLabel}
                newTab={linkNewTab}
                variant={linkAsButton ? buttonVariant : textLinkVariant}
              />
            </div>
          )}
        </div>
      </Container>
    </Section>
  )
}
